export default "__VITE_ASSET__Bv5H2EhV__"